import { socket } from "app/api/socket";
import { ClientChatResponse, MessageLocal, MessageResponse } from "app/api/types";
import { DateTime } from "luxon";
import getChatToken from "app/api/getChatToken";

export const GET_REGISTRATION = "GET_REGISTRATION";
export const GET_MESSAGE = "GET_MESSAGE";
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const RESET_NOTIFICATION = "RESET_NOTIFICATION";

export const openSocket = () => (dispatch: any): any => {
	if (socket.isAlive) return;

	const token = getChatToken();
	socket.start(
		token,
		getMessage(dispatch),
		getTypingNotification(dispatch),
		getRegistration(dispatch)
	);
}

const getMessage = (dispatch: any) => (message: MessageResponse) => {
	const clientId = message.isIncoming ? message.senderId : message.receiverId;
	const messageLocal: MessageLocal = {
		...message,
		time: DateTime.fromISO(message.time),
	};
	dispatch({ type: GET_MESSAGE, payload: { clientId: clientId, message: messageLocal } });
}

const getTypingNotification = (dispatch: any) => (user: ClientChatResponse) => {
	dispatch({ type: GET_NOTIFICATION, payload: user });
	setTimeout(() => {
		dispatch({ type: RESET_NOTIFICATION, payload: user });
	}, 3000);
}

const getRegistration = (dispatch: any) => (user: ClientChatResponse) => {
	dispatch({ type: GET_REGISTRATION, payload: user });
}
